webpackJsonp([167162341887009],{

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/career-header-big.7525bd84.jpg";

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/career-header-small.62c6be63.jpg";

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Hero = __webpack_require__(12);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _careerHeaderBig = __webpack_require__(110);
	
	var _careerHeaderBig2 = _interopRequireDefault(_careerHeaderBig);
	
	var _careerHeaderSmall = __webpack_require__(111);
	
	var _careerHeaderSmall2 = _interopRequireDefault(_careerHeaderSmall);
	
	var _Layout = __webpack_require__(7);
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var career = data.markdownRemark;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Hero2.default,
	      {
	        imageBig: _careerHeaderBig2.default,
	        imageSmall: _careerHeaderSmall2.default
	      },
	      _react2.default.createElement(
	        _Layout.Box,
	        { color: 'white', p: [3, 3, 4], align: 'left' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          career.frontmatter.title
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Layout.Box,
	      {
	        color: _colors2.default.black,
	        py: '2rem',
	        pl: ['2em', '4em', '6em', '20em'],
	        pr: ['2em', '4em', '6em', '20em'],
	        align: 'left'
	      },
	      _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: career.html } })
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-career-template-js-66e5878e6e4fd9d297bd.js